module.exports = __webpack_public_path__ + "static/media/USSF-90-Min-Display-Light.0de5ac3a.woff2";